import React, {useContext} from "react";
import "./Footer.scss";
import Pulse from "react-reveal/Pulse";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Pulse>
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ♥️ by Sarthak Kumar Shailendra")}
        </p>
      </div>
    </Pulse>
  );
}
